import { ReactElement } from 'react';

import * as graphql from '@treams/treams-network';

import { pickEvaluationSectionItem } from '../utilities/pickEvaluationSectionItem';
import CompetencyModal from './modals/CompetencyModal';
import DevelopmentPlanModal from './modals/DevelopmentPlanModal';
import FinalScoreModal from './modals/FinalScoreModal';
import MultipleChoiceModal from './modals/MultipleChoiceModal';
import OpenQuestionModal from './modals/OpenQuestionModal';
import ParagraphModal from './modals/ParagraphModal';
import ReviewGoalsModal from './modals/ReviewGoalsModal';
import SentimentModal from './modals/SentimentModal';
import SetGoalsModal from './modals/SetGoalsModal';
import SignatureModal from './modals/SignatureModal';
import StarsModal from './modals/StarsModal';
import TitleModal from './modals/TitleModal';

export default function EditModal(props: {
	item: graphql.EvaluationSectionItem;
	onUpdate: (id: string, item?: graphql.EvaluationSectionItem) => void;
}): ReactElement {
	const modal = pickEvaluationSectionItem<() => React.ReactElement>(props.item, {
		competency: () => (
			<CompetencyModal
				fillInBy={props.item.fillInBy}
				item={props.item.competency!}
				onChange={(competency, fillInBy) => {
					props.onUpdate(props.item.id, {
						...props.item,
						competency,
						fillInBy,
					});
				}}
			/>
		),

		multipleChoice: () => (
			<MultipleChoiceModal
				fillInBy={props.item.fillInBy}
				optional={props.item.optional}
				item={props.item.multipleChoice!}
				onChange={(multipleChoice, fillInBy, optional) =>
					props.onUpdate(
						props.item.id,
						multipleChoice
							? {
									...props.item,
									multipleChoice,
									fillInBy,
									optional,
								}
							: undefined,
					)
				}
			/>
		),

		openQuestion: () => (
			<OpenQuestionModal
				fillInBy={props.item.fillInBy}
				optional={props.item.optional}
				item={props.item.openQuestion!}
				onChange={(openQuestion, fillInBy, optional) =>
					props.onUpdate(props.item.id, {
						...props.item,
						openQuestion,
						fillInBy,
						optional,
					})
				}
			/>
		),

		sentiment: () => (
			<SentimentModal
				fillInBy={props.item.fillInBy}
				optional={props.item.optional}
				item={props.item.sentiment!}
				onChange={(sentiment, fillInBy, optional) =>
					props.onUpdate(props.item.id, {
						...props.item,
						sentiment,
						fillInBy,
						optional,
					})
				}
			/>
		),

		signature: () => (
			<SignatureModal
				fillInBy={props.item.fillInBy}
				item={props.item.signature!}
				onChange={(signature, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						signature,
						fillInBy,
					})
				}
			/>
		),

		stars: () => (
			<StarsModal
				fillInBy={props.item.fillInBy}
				optional={props.item.optional}
				item={props.item.stars!}
				onChange={(stars, fillInBy, optional) =>
					props.onUpdate(props.item.id, {
						...props.item,
						stars,
						fillInBy,
						optional,
					})
				}
			/>
		),

		title: () => (
			<TitleModal
				fillInBy={props.item.fillInBy}
				item={props.item.title!}
				onChange={(title, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						title,
						fillInBy,
					})
				}
			/>
		),

		paragraph: () => (
			<ParagraphModal
				fillInBy={props.item.fillInBy}
				item={props.item.paragraph!}
				onChange={(paragraph, fillInBy) =>
					props.onUpdate(
						props.item.id,
						paragraph
							? {
									...props.item,
									paragraph,
									fillInBy,
								}
							: undefined,
					)
				}
			/>
		),

		finalScore: () => (
			<FinalScoreModal
				fillInBy={props.item.fillInBy}
				item={props.item.finalScore!}
				onChange={(finalScore, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						finalScore,
						fillInBy,
					})
				}
			/>
		),

		reviewGoals: () => (
			<ReviewGoalsModal
				fillInBy={props.item.fillInBy}
				item={props.item.reviewGoals!}
				onChange={(reviewGoals, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						reviewGoals,
						fillInBy,
					})
				}
			/>
		),

		developmentPlan: () => (
			<DevelopmentPlanModal
				fillInBy={props.item.fillInBy}
				item={props.item.developmentPlan!}
				onChange={(developmentPlan, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						developmentPlan,
						fillInBy,
					})
				}
			/>
		),

		setGoals: () => (
			<SetGoalsModal
				fillInBy={props.item.fillInBy}
				item={props.item.setGoals!}
				onChange={(setGoals, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						setGoals,
						fillInBy,
					})
				}
			/>
		),
	});

	return modal();
}
